import React, { useState } from "react";
import { useSelector } from "react-redux";

import Divider from "@mui/material/Divider";

import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import SourceManagment from "../sources/components/SourceManagment";
import AssetFilters from "./AssetFilters";

const KnowledgeBase = () => {
	const { profile } = useSelector(state => state);

	const [filters, setFilters] = useState({
		status: [],
		access: [],
		type: [],
		dateStart: "",
		dateEnd: ""
	});

	const handleFilterChange = (filterType, value) => {
		setFilters(prev => ({
			...prev,
			[filterType]: value
		}));
	};

	return (
		<DashboardLayout flex>
			<DashboardNavbar
				filters={[
					[
						<AssetFilters
							key="asset-filters"
							filters={filters}
							onFilterChange={handleFilterChange}
						/>
					]
				]}
			/>
			<Divider />
			<SourceManagment assistantID={profile?.assistantID} activeFilters={filters} />
		</DashboardLayout>
	);
};

export default KnowledgeBase;
